// extracted by mini-css-extract-plugin
export default {"valueCard":"valueCard","gaugeSvgWrapper":"gaugeSvgWrapper","gaugeDesktop":"gaugeDesktop","gaugeMobile":"gaugeMobile","forensicGaugeSvg":"forensicGaugeSvg"};